import { MatSnackBar } from "@angular/material/snack-bar";
import { SnakBarAlertComponent } from "./components/snak-bar-alert/snak-bar-alert.component";

export class Utils {
    public static filterArrayByString(mainArr: any[], searchText: string) {
        if ( searchText === '' ) {
            return mainArr;
        }

        searchText = searchText.toLowerCase();

        return mainArr.filter(itemObj => {
            return this.searchInObj(itemObj, searchText);
        });
    }

    public static searchInObj(itemObj: { [x: string]: any; hasOwnProperty: (arg0: string) => any; }, searchText: string): boolean {
        for ( const prop in itemObj ) {
            if ( !itemObj.hasOwnProperty(prop) ) {
                continue;
            }

            const value = itemObj[prop];

            if ( typeof value === 'string' ) {
                if ( this.searchInString(value, searchText) ) {
                    return true;
                }
            } else if ( Array.isArray(value) ) {
                if ( this.searchInArray(value, searchText) ) {
                    return true;
                }
            }

            if ( typeof value === 'object' ) {
                if ( this.searchInObj(value, searchText) ) {
                    return true;
                }
            }
        }

        return false;
    }

    public static searchInArray(arr: any[], searchText: string): boolean {
        for ( const value of arr ) {
            if ( typeof value === 'string' ) {
                if ( this.searchInString(value, searchText) ) {
                    return true;
                }
            }

            if ( typeof value === 'object' ) {
                if ( this.searchInObj(value, searchText) ) {
                    return true;
                }
            }
        }

        return false;
    }

    public static searchInString(value: string, searchText: string) {
        return value.toLowerCase().includes(searchText);
    }

    public static generateGUID() {
        function S4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                       .toString(16)
                       .substring(1);
        }

        return S4() + S4();
    }

    public static toggleInArray(item: any, array: any[]) {
        if ( array.indexOf(item) === -1 ) {
            array.push(item);
        } else {
            array.splice(array.indexOf(item), 1);
        }
    }

    public static handleize(text: { toString: () => string; }) {
        return text.toString().toLowerCase()
                   .replace(/\s+/g, '-')           // Replace spaces with -
                   .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
                   .replace(/\-\-+/g, '-')         // Replace multiple - with single -
                   .replace(/^-+/, '')             // Trim - from start of text
                   .replace(/-+$/, '');            // Trim - from end of text
    }

    public static showMessage(
        instance: MatSnackBar,
        message: string,
        subMessage: string,
        type: 'success' | 'warning' | 'error',
        duration: number = 3000
    ) {
        let contactSupport = false;
        if (type === 'error' && subMessage.includes('favor intentelo')) {
            message = 'Algo salió mal'
            subMessage = 'Estamos trabajando para solucionarlo.<br>Por favor intenta de nuevo o si requieres más asistencia pulsa este botón';
            duration = 4500;
            contactSupport = true;
        }

        instance.openFromComponent(SnakBarAlertComponent, {
            data: {
                message,
                subMessage,
                type,
                contactSupport
            },
            panelClass: 'snack-message',
            horizontalPosition: 'right',
            verticalPosition: 'top',
            duration
        });
    }
}
